import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IApp } from '@core/models/app.interfaces';
import { CombinedPropertyService } from '@core/services/combinedProperty.service';
import { StoreService } from '@core/store/store.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { STATUS_ICON} from '@shared/shared.const';
import { DocumentsComponent } from '../documents/documents.component';

@Component({
  selector: 'app-upload-pending-documents',
  templateUrl: './upload-pending-documents.component.html',
  styleUrls: ['./upload-pending-documents.component.scss'],
  imports: [TranslateModule, FontAwesomeModule, CommonModule, DocumentsComponent],
})
export class UploadPendingDocumentsComponent implements OnInit {

  docAllowedFileTypes: string;
  docAllowedSize: string;
  statusIcon = STATUS_ICON;

  @Input() pendingDocumentMetaData: IApp.IPendingDocumentMetaData;
  @Input() hideTitleAndDescription: boolean = false;
  @Output() documentResult = new EventEmitter<IApp.IEmmitedDocs>();


  constructor( private storeService: StoreService,
    private combinedPropertyService : CombinedPropertyService,
  ) { }
  ngOnInit() {
    // this.storeService.getAllowedDocTypes().subscribe(
    //   prop => this.docAllowedFileTypes = prop.value,
    // );
    let combinedProperty = '';
    if(this.pendingDocumentMetaData.fileExtension && this.pendingDocumentMetaData.sizeProperty){
      combinedProperty = this.pendingDocumentMetaData.fileExtension + ',' + this.pendingDocumentMetaData.sizeProperty;
    }
    else if(this.pendingDocumentMetaData.fileExtension){
      combinedProperty = this.pendingDocumentMetaData.fileExtension;
    }
    else if(this.pendingDocumentMetaData.sizeProperty){
      combinedProperty = this.pendingDocumentMetaData.sizeProperty;
    }
    this.combinedPropertyService.getCombinedProperty(combinedProperty).subscribe(
      data =>{
        if(data[this.pendingDocumentMetaData.fileExtension].value)
        this.docAllowedFileTypes = data[this.pendingDocumentMetaData.fileExtension].value; 
        if(data[this.pendingDocumentMetaData.sizeProperty].value)
        this.docAllowedSize = data[this.pendingDocumentMetaData.sizeProperty].value;
      });
    this.pendingDocumentMetaData.documentUploadConfig.showHeader = true;
  }

 updateDocumentDetails(documents: IApp.IEmmitedDocs) {
    this.documentResult.emit(documents);
  }
}
